import Avatar from "@mui/material/Avatar";
import { PagePermissions } from "./roles";
import { iUser } from "../interfaces/Auth/iUser";
import OrganizacionesCardImg from "../components/Admin/img/OrganizacionesCardImg.png";
import RolesCardImg from "../components/Admin/img/RolesCardImg.png";
import PlanesCardImg from "../components/Admin/img/PlanesCardImg.png";
import SuscripcionesCardImg from "../components/Admin/img/SuscripcionesCardImg.png";
import UsuariosCardImg from "../components/Admin/img/UsuariosCardImg.png";
import ReportesAuditoriasCardImg from "../components/Admin/img/ReportesAuditoriasCardImg.png";
import DashboardCardImg from "../components/Admin/img/DashboardCardImg.png";

interface AdminCard {
  title: string;
  description: string;
  route: string;
  image: string;
  alt: string;
  permission: PagePermissions | PagePermissions[] | null;
}

export const getAdminCards = (user: iUser): AdminCard[] => {
  return [
    {
      title: "Organizaciones",
      description:
        "Visualiza, organiza y gestiona información clave de cada organización para asegurar un manejo eficiente.",
      route: "organizations",
      image: OrganizacionesCardImg,
      alt: "Imagen tarjeta de organización",
      permission: "view:organization",
    },
    {
      title: "Organización",
      description:
        "Visualiza, organiza y gestiona información clave de tu organización para asegurar un manejo eficiente.",
      route: `organizations/${user.id_organizacion}`,
      image: OrganizacionesCardImg,
      alt: "Imagen tarjeta de organización",
      permission: "view:ownOrganization",
    },
    {
      title: "Roles",
      description:
        "Configura permisos personalizados para gestionar y acceder a cada aplicación de la plataforma.",
      route: "roles",
      image: RolesCardImg,
      alt: "Imagen tarjeta de roles",
      permission: "view:roles",
    },
    {
      title: "Roles",
      description:
        "Configura permisos personalizados para gestionar y acceder a cada aplicación de la plataforma.",
      route: `roles/${user.id_organizacion}`,
      image: RolesCardImg,
      alt: "Imagen tarjeta de roles",
      permission: "view:ownRoles",
    },
    {
      title: "Planes",
      description:
        "Crea y gestiona planes ajustando características y opciones para satisfacer necesidades especificas.",
      route: "plans",
      image: PlanesCardImg,
      alt: "Imagen tarjeta de planes",
      permission: "view:plans",
    },
    {
      title: "Planes",
      description:
        "Observa los planes destinados para tu organización y escoje la mejor opción para ti.",
      route: `plans/${user.id_organizacion}`,
      image: PlanesCardImg,
      alt: "Imagen tarjeta de planes",
      permission: "view:ownPlans",
    },
    {
      title: "Suscripciones",
      description:
        "Supervisa y administra suscripciones activas. Simplifica el manejo de renovaciones, estados y vigencias.",
      route: "suscriptions",
      image: SuscripcionesCardImg,
      alt: "Imagen tarjeta de suscripciones",
      permission: "view:suscriptions",
    },
    {
      title: "Suscripciones",
      description:
        "Supervisa y administra suscripciones activas. Simplifica el manejo de renovaciones, estados y vigencias.",
      route: `suscriptions/${user.id_organizacion}`,
      image: SuscripcionesCardImg,
      alt: "Imagen tarjeta de suscripciones",
      permission: "view:ownSuscriptions",
    },
    {
      title: "Usuarios",
      description:
        "Controla y organiza perfiles de usuarios, gestiona accesos y personaliza la experiencia según cada perfil.",
      route: "users",
      image: UsuariosCardImg,
      alt: "Imagen tarjeta de usuarios",
      permission: "view:users",
    },
    {
      title: "Usuarios",
      description:
        "Controla y organiza perfiles de usuarios de tu organización, gestiona accesos y personaliza la experiencia según cada perfil.",
      route: `users/${user.id_organizacion}`,
      image: UsuariosCardImg,
      alt: "Imagen tarjeta de usuarios",
      permission: "view:ownUsers",
    },
    {
      title: "Reportes & Auditorías",
      description:
        "Realiza un seguimiento detallado de las actividades y estadísticas, analiza datos y asegura transparencia en la gestión.",
      route: "auditorias/eventos/organizacion",
      image: ReportesAuditoriasCardImg,
      alt: "Imagen tarjeta de reportes y auditorías",
      permission: "view:reports",
    },
    {
      title: "Reportes & Auditorías",
      description:
        "Realiza un seguimiento detallado de las actividades y estadísticas, analiza datos y asegura transparencia en la gestión.",
      route: `auditorias/eventos/organizacion/${user.id_organizacion}`,
      image: ReportesAuditoriasCardImg,
      alt: "Imagen tarjeta de reportes y auditorías",
      permission: "view:ownReports",
    },
    {
      title: "Dashboards",
      description:
        "Observa los gastos de créditos para las organización basado en distintos parámetros.",
      route: "dashboard/organizations",
      image: DashboardCardImg,
      alt: "Imagen tarjeta de dashboard",
      permission: "view:dashboard",
    },
    {
      title: "Dashboards",
      description:
        "Observa los gastos de créditos para tu organización basado en distintos parámetros.",
      route: `dashboard/${user.id_organizacion}/organization`,
      image: DashboardCardImg,
      alt: "Imagen tarjeta de dashboard",
      permission: "view:ownDashboard",
    },
    {
      title: "OAS",
      description:
        "Crea objetivos de aprendizaje personalizados para las organizaciones, así como sus niveles y asignaturas.",
      route: `oas`,
      image: DashboardCardImg,
      alt: "Imagen tarjeta de OAS",
      permission: "view:oas",
    },
    {
      title: "OAS",
      description:
        "Crea objetivos de aprendizaje personalizados para tu organización, así como tus niveles y asignaturas.",
      route: `oas/${user.id_organizacion}`,
      image: DashboardCardImg,
      alt: "Imagen tarjeta de OAS",
      permission: "view:ownOas",
    },
  ];
};


      